import PullRefresh from 'react-pullrefresh'
import {useTheme} from '@material-ui/core'
const MyPullRefresh = (props)=> {
    const theme = useTheme()
    return <PullRefresh bgColor={theme.palette.background.paper} color={theme.palette.primary.main} {...props}/>
}
export default MyPullRefresh